import api from "../../../config/axios/configAxios";
import i18next from "i18next";
import { ShortLangToEnum } from "../../../features/common/converters/language";
import { IDetailedPriceParams, IDatailedReportParams } from "../model";

export const getDetailedPrices = async (params?: IDetailedPriceParams) =>
  api.get(`/api/Admin/Prices/detailed`, { params });

export const getDatailedReport = async (params?: IDatailedReportParams, fileName?: string) => {
  const res = await api.get("/api/Admin/Prices/detailed/report", {
    responseType: 'blob',
    params: { ...params, langId: ShortLangToEnum(i18next.language) }
  })

    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName || 'Raport'}.xlsx`);
    document.body.appendChild(link);
    link.click();
};